import { FeedbackTable } from '@/components/admin/feedback-table';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authed/admin/feedback')({
  component: AdminFeedbackRoute,
});

function AdminFeedbackRoute() {
  return <FeedbackTable />;
}
